module.exports = __webpack_public_path__ + "img/email.c80d9972.svg";